import instaciaAxios from './InterceptorAxios';

const servicioTicket = {
    buscarTickets(urlBusqueda) {
        return instaciaAxios.post(urlBusqueda);
    },
    validarTicket(urlValidarTickets, ticket) {
        return instaciaAxios.post(urlValidarTickets, ticket);
    },
    eliminarTicket(urlEliminarTickets, ticket) {
        return instaciaAxios.post(urlEliminarTickets, ticket);
    },
    generarFactura(urlGenerarFacturaTickets, receptor) {
        return instaciaAxios.post(urlGenerarFacturaTickets, receptor);
    },
    reporte_total_afores(obj){
        return instaciaAxios.post("ticket/reporte_total_afores.json", obj);
    }
}

export default servicioTicket;